/** IMPORT */
import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcListConfig} from 'exc-controls';
import {ExcFilter, ExcFilterCondition} from '../../../filter-sort-service.service';
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
  TableService,
  RichTextEditorComponent
} from '@syncfusion/ej2-angular-richtexteditor';
import {ExcCheckboxComponent} from "exc-controls/lib/form-controls/exc-checkbox/exc-checkbox.component";

/**
 * COMPONENT
 */
@Component({
  selector: 'app-selfcheck-config',
  templateUrl: './sc-config.component.html',
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService]
})
/**
 * Klasse für die Einstellungen und Menüpunkte eines Selfchecks. <br>
 * @version Angular 7.0.0 <br>
 * @since 17.10.2022 <br>
 * xx.xx.xxxx wg. Evaluierung <br>
 * 17.10.2022 wg. Dokumentation <br>
 * @author Denny M. Lüdicke <br> E-Mail: denny.luedicke@excon.com <br>
 * Veränderungen von Denny M. Lüdicke
 **/
export class ScConfigComponent extends ExcTranslation implements OnInit {
  /**
   * VIEW
   */
  @ViewChild('MessageWelcome') VCMessageWelcome: RichTextEditorComponent;
  @ViewChild('MessageGoodbye') VCMessageGoodbye: RichTextEditorComponent;
  @ViewChild('MessageRejection') VCMessageRejection: RichTextEditorComponent;
  @ViewChild('MessagePinBlockedText') VCMessagePinBlockedText: RichTextEditorComponent;


  /**
   * ATTRIBUTE
   */
  verificationKey: string | undefined;
  selfcheckMode = [this.getRessource('SelfcheckVehicles'), this.getRessource('SelfcheckDocuments')];
  seflcheckModeVariable: string | undefined;
  selectedRow: any;
  SearchValue = '';
  editMode = false;
  qrTimeStart: any;
  qrTimeEnd: any;
  sendMailTime: any;

  private sequenceIsLoading: boolean;
  private startQrTime = '07:00';
  private endQrTime = '22:00';
  private emailSendTime = '05:00';
  private exconSenderAdress = "@excon.com";

  public tools: object =
    {
      items:
        [
          'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
          'LowerCase', 'UpperCase', '|', 'Undo', 'Redo', '|',
          'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
          'Indent', 'Outdent', '|', 'CreateLink', 'CreateTable',
          'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen'
        ]
    };


  // WIP Start
  private beforeStartSelfcheckNotComplete: boolean = true;
  private beforeEndSelfcheckNotComplete: boolean = false;

  private beforeStartSelfcheckNotFinished: boolean = true;
  private beforeEndSelfcheckNotFinished: boolean = false;

  private beforeStartSelfcheckNotStarted: boolean = true;
  private beforeEndSelfcheckNotStarted: boolean = false;
  // WIP Ende

  /**
   * Werkbank
   */
  selfcheckConfigData =
    {
      isLoading: true,
      Header: {} as any,
      Enumeration:
        {
          Steps: [] as any[],
        },

      Workspace:
        {
          /** Message Texts Clone **/
          messageTexts: {cfgWelcomeText: '', cfgGoodbyeText: '', cfgRejectionText: ''},
          messageTextsClone: {} as any,
          loadMessageTexts: (cfgWelcomeText: string, cfgGoodbyeText: string, cfgRejectionText: string) => {
            this.selfcheckConfigData.Workspace.messageTexts = {cfgWelcomeText, cfgGoodbyeText, cfgRejectionText};
            this.selfcheckConfigData.Workspace.messageTextsClone = this.clone(this.selfcheckConfigData.Workspace.messageTexts);
          },
          messageTextsChanged: (): boolean => {
            return this.changed(this.selfcheckConfigData.Workspace.messageTexts, this.selfcheckConfigData.Workspace.messageTextsClone);
          },
          /** Emails Clone **/
          emails: {
            cfgMailSender: '',
            cfgMailSenderShort: '',
            cfgCancelIfNoData: false,
            cfgSendItemsPerMail: false,
            cfgSendPreInfo: false,
            cfgPinBlockedText: '',
            cfgSendMailOnCancel: false,
            cfgHourValidFrom: '',
            cfgHourValidTo: '',
            cfgHourSendMail: ''
          },
          emailsClone: {} as any,
          loadEmails: (cfgMailSender: string, cfgCancelIfNoData: boolean, cfgSendItemsPerMail: boolean, cfgSendPreInfo: boolean, cfgPinBlockedText: string, cfgSendMailOnCancel: boolean, cfgHourValidFrom: string, cfgHourValidTo: string, cfgHourSendMail: string) => {
            let cfgMailSenderShort = cfgMailSender.replace(this.exconSenderAdress, '');
            this.selfcheckConfigData.Workspace.emails = {
              cfgMailSender,
              cfgMailSenderShort,
              cfgCancelIfNoData,
              cfgSendItemsPerMail,
              cfgSendPreInfo: cfgSendPreInfo,
              cfgPinBlockedText,
              cfgSendMailOnCancel,
              cfgHourValidFrom,
              cfgHourValidTo,
              cfgHourSendMail
            };
            //console.log(this.selfcheckConfigData.Workspace.emails);
            this.selfcheckConfigData.Workspace.emailsClone = this.clone(this.selfcheckConfigData.Workspace.emails);
          },
          emailsChanged: (): boolean => {
            return this.changed(this.selfcheckConfigData.Workspace.emails, this.selfcheckConfigData.Workspace.emailsClone);
          },
          emailsCancel: (): void => {
            this.selfcheckConfigData.Workspace.emailsClone = this.clone(this.selfcheckConfigData.Workspace.emails);
          },
          /** Warnung Clone **/
          warnungen: {
            cfgWarning_NotCompleted: 0,
            cfgWarning_NotFinished: 0,
            cfgWarning_NotStarted: 0,
            cfgWarningBCC: ''
          },
          warnungenClone: {} as any,
          loadWarnungen: (cfgWarning_NotCompleted: number, cfgWarning_NotFinished: number, cfgWarning_NotStarted: number, cfgWarningBCC: string) => {
            this.selfcheckConfigData.Workspace.warnungen = {
              cfgWarning_NotCompleted,
              cfgWarning_NotFinished,
              cfgWarning_NotStarted,
              cfgWarningBCC
            };
            this.selfcheckConfigData.Workspace.warnungenClone = this.clone(this.selfcheckConfigData.Workspace.warnungen);
          },
          warnungenChanged: (): boolean => {
            return this.changed(this.selfcheckConfigData.Workspace.warnungen, this.selfcheckConfigData.Workspace.warnungenClone);
          },
          warnungenCancel: (): void => {
            this.selfcheckConfigData.Workspace.warnungenClone = this.clone(this.selfcheckConfigData.Workspace.warnungen);
          },
          /** Allgemein Clone **/
          generals: {cfgGroupSubtypeMails: false, cfgGuaranteedDuration: false, cfgPinRequired: false,},
          generalsClone: {} as any,
          loadGenerals: (cfgGroupSubtypeMails: boolean, cfgGuaranteedDuration: boolean, cfgPinRequired: boolean) => {
            this.selfcheckConfigData.Workspace.generals = {cfgGroupSubtypeMails, cfgGuaranteedDuration, cfgPinRequired};
            this.selfcheckConfigData.Workspace.generalsClone = this.clone(this.selfcheckConfigData.Workspace.generals);
          },
          generalsChanged: (): boolean => {
            return this.changed(this.selfcheckConfigData.Workspace.generals, this.selfcheckConfigData.Workspace.generalsClone);
          },
          generalsCancel: (): void => {
            this.selfcheckConfigData.Workspace.generalsClone = this.clone(this.selfcheckConfigData.Workspace.generals);
          },
          /** Sequenzen Clone **/
          sequences: [] as any[],
          sequencesClone: [] as any[],
          sequencesChanged: (): boolean => {
            return this.changed(this.selfcheckConfigData.Workspace.sequences, this.selfcheckConfigData.Workspace.sequencesClone);
          },
          /** Style **/
          loadDataSequences: (sequenz: any[]) => {
            for (const sequenzItem of sequenz) {
              Object.assign(sequenzItem, {isVisible: false, isSequenceStepVisible: false});
              this.selfcheckConfigData.Workspace.sequences.push(sequenzItem);
              this.selfcheckConfigData.Workspace.sequencesClone.push(sequenzItem);
            }
          },
        },
      loadData: (header: any, sequenz: any[], steps: any[]) => {
        this.selfcheckConfigData.Header = header;
        // this.selfcheckConfigData.Sequences = sequenz;
        this.selfcheckConfigData.Workspace.loadMessageTexts(header.cfgWelcomeText, header.cfgGoodbyeText, header.cfgRejectionText);
        this.selfcheckConfigData.Workspace.loadEmails(
          header.cfgMailSender,
          header.cfgCancelIfNoData,
          header.cfgSendItemsPerMail,
          header.cfgSendPreInfo,
          header.cfgPinBlockedText,
          header.cfgSendMailOnCancel,
          header.cfgHourValidFrom,
          header.cfgHourValidTo,
          header.cfgHourSendMail);
        this.selfcheckConfigData.Workspace.loadWarnungen(header.cfgWarning_NotCompleted, header.cfgWarning_NotFinished, header.cfgWarning_NotStarted, header.cfgWarningBCC);
        this.selfcheckConfigData.Workspace.loadGenerals(header.cfgGroupSubtypeMails, header.cfgGuaranteedDuration, header.cfgPinRequired,);
        // this.selfcheckConfigData.Workspace.loadSequenzen(sequences.seqName, sequences.seqSubtype, sequences.Steps.rpCode, sequences.Steps.rpCodeDescription, sequences.Steps.ssCaption, sequences.Steps.ssTip, sequences.Steps.stCaption, );
        // this.selfcheckConfigData.Workspace.loadStepsValue(steps.stID , steps.stCaption , steps.stDescription , steps.stImagesMin , steps.stImagesMax );
        this.selfcheckConfigData.Workspace.loadDataSequences(sequenz);
        this.selfcheckConfigData.Enumeration.Steps = steps;
      },
    };
  selfcheckListConfig: ExcListConfig = new ExcListConfig();
  selfcheckConfigListData: any[] =
    [
      {name: 'MessageTexts', isMainPoint: true},
      {name: 'Emails', isMainPoint: true},
      {name: 'Warnings', isMainPoint: true},
      {name: 'General', isMainPoint: true},
      {name: 'Sequences', isMainPoint: true}
    ];
  changedHeaderInformation =
    {
      cfgSequenceMode: "",
      cfgWelcomeText: "",
      cfgGoodbyeText: "",
      cfgRejectionText: "",
      cfgMailSender: "riskplatform-demo@excon.com",
      cfgCancelIfNoData: false,
      cfgSendItemsPerMail: false,
      cfgSendPreInfo: false,
      cfgPinRequired: false,
      cfgPinBlockedText: "",
      cfgWarning_NotCompleted: 0,
      cfgWarning_NotFinished: 0,
      cfgWarning_NotStarted: 0,
      cfgWarningBCC: "",
      cfgSendMailOnCancel: false,
      cfgGuaranteedDuration: false,
      cfgGroupSubtypeMails: false,
      cfgHourValidFrom: "",
      cfgHourValidTo: "",
      cfgHourSendMail: ""
    };


  /**
   * METHODEN
   */

  /**
   * @param constructor( ExcRestService, ChangeDetectorRef , ExcSigninService )
   */
  constructor(private excrest: ExcRestService, private ref: ChangeDetectorRef, private excSec: ExcSigninService) {
    super();
    const _self = this;
    _self.selfcheckListConfig.OnSearch = (searchValue) => {
      _self.SearchValue = searchValue;
    };
    _self.selfcheckListConfig.OnRefresh = (event) => {
    };
    _self.selfcheckListConfig.OnSelectionChanged = (selectedItems, event1) => {
      _self.selectedRow = selectedItems[0];
      // console.log(this.selectedRow, this.selfcheckConfigListData[0]);
    };
    _self.selfcheckListConfig.selectFirstAfterInit = true;
    // console.log(this.selfcheckSequenzListData);
  }

  /**
   * @param ngOnInit()
   */
  ngOnInit() {
    this.init();

  }

  /**
   * @param init()
   */
  private init() {
    this.loadSelfcheckConfig();
  }

  /**
   * GETTER
   */
  /**
   * @param getStartQr( any )
   * Verarbeitung für startQrTime
   */
  setStartQrTime(startQrTime: any) {
    const [qrHours, qrMinutes] = startQrTime.split(':').map(Number);
    const qrTimStart = qrHours * 60 + qrMinutes;

    this.qrTimeStart = qrHours;
    this.selfcheckConfigData.Workspace.emailsClone.cfgHourValidFrom = qrTimStart;

    this.startQrTime = `${String(Math.floor(qrTimStart / 60)).padStart(2, '0')}:${String(qrTimStart % 60).padStart(2, '0')}`;
  }

  /**
   * @param getEndQr( any )
   * Verarbeitung für endQrTime
   */
  setEndQrTime(endQrTime: any) {
    const [qrEndHours, qrEndMinutes] = endQrTime.split(':').map(Number);
    const qrTimEnd = qrEndHours * 60 + qrEndMinutes;

    this.qrTimeEnd = qrEndHours;
    this.selfcheckConfigData.Workspace.emailsClone.cfgHourValidTo = qrTimEnd;

    this.endQrTime = `${String(Math.floor(qrTimEnd / 60)).padStart(2, '0')}:${String(qrTimEnd % 60).padStart(2, '0')}`;
  }

  /**
   * @param getSendSelfcheck( any )
   * Email Send Time Verarbeitung
   */
  setSendSelfcheckTime(emailSendTime: any) {
    const [hoursInt, minutesInt] = emailSendTime.split(':').map(Number);
    const timSendMail = hoursInt * 60 + minutesInt;

    this.sendMailTime = hoursInt;
    this.selfcheckConfigData.Workspace.emailsClone.cfgHourSendMail = timSendMail;

    this.emailSendTime = `${String(Math.floor(timSendMail / 60)).padStart(2, '0')}:${String(timSendMail % 60).padStart(2, '0')}`;
  }


  /**
   * @param loadSelfcheckConfig()
   */
  loadSelfcheckConfig() {
    const _self = this;
    const metainfo = {};

    _self.selfcheckConfigData.isLoading = true;
    _self.sequenceIsLoading = true;

    _self.excrest.sget(this.excrest.computeUrl(
        'SelfcheckConfigR_Summary',
        {}),
      ExcCoreModule.Guid.NewGuid(),
      {MetaInfo: metainfo}).subscribe(response => {
      // console.log( response.response.data.Header.cfgGoodbyeText );
      if (response.response !== undefined && response.response !== null) {
        _self.selfcheckConfigData.loadData(
          response.response.data.Header,
          response.response.data.Sequences,
          response.response.data.Steps,
        );
        _self.selfcheckConfigData.isLoading = false;
        _self.sequenceIsLoading = false;
      }
      else {
        _self.selfcheckConfigData.isLoading = false;
        _self.sequenceIsLoading = false;
      }

      //console.log(this.selfcheckConfigData.Workspace.sequences);

    });
  }

  /**
   * @param clone( any )
   */
  clone(cloneObj: any): any {
    return JSON.parse(JSON.stringify(cloneObj));
  }

  /**
   * @param changed( any, any )
   * @return Object
   */
  changed(objBefore: any, objAfter: any): boolean {
    return JSON.stringify(objBefore) !== JSON.stringify(objAfter);
  }

  /**
   * @param changeEditMode()
   */
  changeEditMode() {
    if (this.editMode === false) {
      this.editMode = true;
    } else {
      this.editMode = false;
    }
    // Kontrolle
    // console.log(this.editMode);
  }

  /**
   * @param isAbort()
   **/
  isAbort() {
    this.editMode = false;
  }

  /**
   * @param messageTabChange( number )
   */
  messageTabChange($event: number) {
    let header = this.selfcheckConfigData.Header;
    this.selfcheckConfigData.Workspace.loadMessageTexts(header.cfgWelcomeText, header.cfgGoodbyeText, header.cfgRejectionText);
  }

  /**
   * @param changeHeaderInformation()
   */
  changeHeaderInformation() {
    //console.log(this.selfcheckConfigData.Workspace.warnungenClone.cfgSendMailOnCancel);
    this.changedHeaderInformation =
      {
        cfgSequenceMode: "One",
        cfgWelcomeText: this.selfcheckConfigData.Workspace.messageTextsClone.cfgWelcomeText,
        cfgGoodbyeText: this.selfcheckConfigData.Workspace.messageTextsClone.cfgGoodbyeText,
        cfgRejectionText: this.selfcheckConfigData.Workspace.messageTextsClone.cfgRejectionText,
        cfgMailSender: this.selfcheckConfigData.Workspace.emailsClone.cfgMailSender,
        cfgCancelIfNoData: this.selfcheckConfigData.Workspace.emailsClone.cfgCancelIfNoData,
        cfgSendItemsPerMail: this.selfcheckConfigData.Workspace.emailsClone.cfgSendItemsPerMail,
        cfgSendPreInfo: this.selfcheckConfigData.Workspace.emailsClone.cfgSendPreInfo,
        cfgPinRequired: this.selfcheckConfigData.Workspace.generalsClone.cfgPinRequired,
        cfgPinBlockedText: this.selfcheckConfigData.Workspace.emailsClone.cfgPinBlockedText,
        cfgWarning_NotCompleted: this.selfcheckConfigData.Workspace.warnungenClone.cfgWarning_NotCompleted,
        cfgWarning_NotFinished: this.selfcheckConfigData.Workspace.warnungenClone.cfgWarning_NotFinished,
        cfgWarning_NotStarted: this.selfcheckConfigData.Workspace.warnungenClone.cfgWarning_NotStarted,
        cfgWarningBCC: this.selfcheckConfigData.Workspace.warnungenClone.cfgWarningBCC,
        cfgSendMailOnCancel: this.selfcheckConfigData.Workspace.emailsClone.cfgSendMailOnCancel,
        cfgGuaranteedDuration: this.selfcheckConfigData.Workspace.generalsClone.cfgGuaranteedDuration,
        cfgGroupSubtypeMails: this.selfcheckConfigData.Workspace.generalsClone.cfgGroupSubtypeMails,
        cfgHourValidFrom: this.qrTimeStart,
        cfgHourValidTo: this.qrTimeEnd,
        cfgHourSendMail: this.sendMailTime
      }
    // Kontrolle
    //console.log(this.changedHeaderInformation);
    this.saveHeader();
    this.loadSelfcheckConfig();
  }

  /**
   * @param saveHeader()
   */
  saveHeader() {
    let header = this.changedHeaderInformation;

    this.sequenceIsLoading = true;
    this.excrest.post(this.excrest.computeUrl
      (
        'SelfcheckConfig_Header_Post',
      ),
      header, {}
    ).subscribe
    (response => {
      //console.log(response);
      if (response && response.data || response.success && response.data.length >= 0) {
        // let changeStep = response.data[0];
        // Object.assign(changeStep, {ssID: changeStep.ssID})

        //console.log(response.data[0]);
        // this.sequenceWorkspace.Steps.push(response.data[0]);
      }
      this.sequenceIsLoading = false;
    });
  }

  /**
   * @param changeMessageWelcomeValue( any )
   */
  changeMessageWelcomeValue(value: any) {
    const instance: any = this.VCMessageWelcome;
    instance.contentModule.getDocument().addEventListener("keydown", function (e: any): void {
      instance.updateValue(); // Aktualisiert den Wert nach der Bearbeitung
      value = instance.value; // Speicherung des geänderten Inhalts in der Variable
    });
  }

  /**
   * @param changeMessageGoodbyeValue( any )
   */
  changeMessageGoodbyeValue(value: any) {
    const instance: any = this.VCMessageGoodbye;
    instance.contentModule.getDocument().addEventListener("keydown", function (e: any): void {
      instance.updateValue(); // Aktualisiert den Wert nach der Bearbeitung
      value = instance.value; // Speicherung des geänderten Inhalts in der Variable
    });
  }

  /**
   * @param changeMessageRejectionValue( any )
   * @description Wird für die Ablehnungseinstellungen gebraucht -- Derzeitig Deaktiviert
   */
  changeMessageRejectionValue(value: any) {
    const instance: any = this.VCMessageRejection;
    instance.contentModule.getDocument().addEventListener("keydown", function (e: any): void {
      instance.updateValue(); // Aktualisiert den Wert nach der Bearbeitung
      value = instance.value; // Speicherung des geänderten Inhalts in der Variable
    });
  }

  /**
   * @param changeMessagePinBlockedTextValue( any )
   */
  changeMessagePinBlockedTextValue(value: any) {
    const instance: any = this.VCMessagePinBlockedText;
    instance.contentModule.getDocument().addEventListener("keydown", function (e: any): void {
      instance.updateValue(); // Aktualisiert den Wert nach der Bearbeitung
      value = instance.value; // Speicherung des geänderten Inhalts in der Variable
    });
  }

  changeEmailSender(value: string) {
    this.selfcheckConfigData.Workspace.emailsClone.cfgMailSenderShort = value;
    this.selfcheckConfigData.Workspace.emailsClone.cfgMailSender = value + this.exconSenderAdress;
  }

}
